// i18n area 'system' — locale ro-RO (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.ro-RO.meta.json.
import type { enUS } from './system'

export const roRO: typeof enUS = {
  diagnostics: {
    title: 'Diagnosticare',
    subtitle: 'Ce nu merge, întâi ce e mai grav — aceeași lentilă ca tvirt diagnose',
    reload: 'Reîncarcă',
    loadError: 'Diagnosticul nu a putut fi citit',
    exportBundle: 'Exportă pachetul',
    exportError: 'Pachetul nu a putut fi creat',
    noProblem: 'Nicio problemă în zonele inspectate',
    nothingInspected: 'NIMIC nu a fost inspectat — acesta nu este un certificat de sănătate',
    inspected: 'Inspectate',
    notInspected: 'NEINSPECTATE',
    localHint: 'Zonele locale ale nodului (unități systemd, journal) se citesc doar din CLI: tvirt diagnose --area local — calea când API-ul nu răspunde.',
    thresholds: 'sarcini eșuate în {hours} h, heartbeat întârziat peste {seconds} s',
    severity: {
      critical: 'Critic',
      warning: 'Avertisment',
      unknown: 'Necunoscut'
    }
  },
  explorer: {
    title: 'Explorator de resurse',
    root: 'Rădăcină',
    empty: 'Nicio resursă în acest scope',
    previewHint: 'Selectează un obiect pentru a-i vedea previzualizarea',
    open: 'Deschide',
    openScoped: 'Deschide lista în acest scope',
    kinds: {
      vm: 'VM',
      vmTemplate: 'Template VM',
      ct: 'CT',
      ctTemplate: 'Template CT',
      app: 'Aplicație',
      overlayNetwork: 'Rețea overlay',
      networkService: 'Serviciu de rețea',
      fabric: 'Fabric',
      subnet: 'Subnet',
      storage: 'Pool de storage',
      disk: 'Disc',
      catalogFile: 'Fișier de catalog',
      ociRegistry: 'Registry OCI',
      ociImage: 'Imagine OCI',
      cephCluster: 'Cluster Ceph',
      backupDestination: 'Destinație de backup',
      user: 'Utilizator',
      group: 'Grup',
      role: 'Rol',
      credential: 'Credențială',
      tag: 'Tag',
      proximityRule: 'Regulă de proximitate'
    }
  },
  tags: {
    title: 'Taguri',
    empty: 'Niciun tag',
    add: 'Adaugă tag',
    remove: 'Elimină',
    name: 'Tag',
    value: 'Valoare',
    save: 'Salvează',
    saveError: 'Nu s-au putut salva tagurile',
    loadError: 'Nu s-a putut încărca vocabularul de taguri',
    noVocabulary: 'Niciun tag disponibil pentru acest tip de resursă',
    overwrite: 'Înlocuiește valoarea actuală',
    createTitle: 'Creează tag',
    editTitle: 'Modifică tagul',
    nameHint: 'Litere, cifre, puncte, cratime și underscore — fără ":" și fără "/"; prefixul tvirt- este rezervat platformei',
    cardinality: 'Cardinalitate',
    cardinalitySingle: 'O singură valoare',
    cardinalityMultiple: 'Mai multe valori',
    cardinalityHint: 'Cu o singură valoare, reatribuirea tagului cere înlocuirea ei',
    autoCreate: 'Creare automată a valorilor',
    autoCreateOn: 'La atribuire',
    autoCreateOff: 'Doar cele declarate',
    autoCreateHint: 'Activat: atribuirea unei valori noi o creează. Dezactivat: se pot atribui doar valorile declarate',
    values: 'Valori',
    noValues: 'Nicio valoare declarată',
    addValue: 'Adaugă valoare',
    duplicateValue: 'Valoare duplicată',
    kinds: 'Tipuri de resurse',
    kindsAll: 'Toate',
    kindsPlaceholder: 'Toate',
    kindsHint: 'Lasă gol pentru a admite orice tip de resursă care acceptă taguri',
    systemChip: 'Sistem',
    deleteCascade: 'Elimină și atribuirile',
    deleteCascadeHint: 'O etichetă încă atribuită unei resurse este refuzată: cu această opțiune valorile și toate atribuirile dispar împreună cu eticheta.'
  },
  scopes: {
    title: 'Scope-uri',
    createTitle: 'Creează scope',
    editTitle: 'Redenumește scope-ul',
    path: 'Cale',
    segment: 'Segment',
    segmentHint: 'Litere mici, cifre și cratime (DNS-1123)',
    parent: 'Părinte',
    rootChip: 'Rădăcină',
    preview: 'Scope nou',
    pickLabel: 'Scope',
    pickHint: 'Unde trăiește obiectul în arborele clusterului — rădăcina sau un vDC din interiorul ei.',
    ociCache: 'Cache OCI (override)',
    appEphemeral: 'Pool-uri efemere pentru aplicații (override)',
    inherit: 'Moștenește',
    inheritsFrom: 'Moștenește de la',
    inheritsCluster: 'Moștenește valoarea implicită a clusterului',
    inheritsNone: 'Moștenește — niciun pool efectiv',
    failoverProtection: 'Protecție la degradare',
    networkWeight: 'Pondere de rețea',
    networkCeil: 'Plafon de rețea (Mbps)',
    protectionProtected: 'Protejat',
    protectionExpendable: 'Sacrificabil la degradare',
    protectionDefault: 'Valoarea implicită a clusterului'
  },
  sysinfo: {
    summary: 'Versiunile platformei în cluster, componentele fiecărui nod, manualul de administrare și licența.',
    platformTitle: 'Platforma TVirt',
    platformSubtitle: 'Versiuni observate pe nodurile clusterului',
    versionOnNodes: '{version} — noduri: {n}',
    versionOnOneNode: '{version} pe 1 nod',
    mixedVersions: 'Mai mult de o versiune a platformei în cluster — de așteptat doar în timpul unei actualizări în curs (cel mult două).',
    tooManyVersions: 'Mai mult de două versiuni ale platformei în cluster — nu este niciodată de așteptat, nici măcar în timpul unei actualizări: verifică nodurile de mai jos.',
    unreportedNodes: 'Încă niciun raport de versiuni de la: {nodes}',
    noVersionsYet: 'Niciun nod nu și-a raportat încă versiunile.',
    nodesUnavailable: 'Lista nodurilor nu este vizibilă cu permisiunile tale — versiunile platformei nu pot fi afișate.',
    colNode: 'Nod',
    manualTitle: 'Manual de administrare',
    manualSubtitle: 'Copie locală, servită de acest cluster',
    manualBody: 'Manualul TVirt complet în PDF, servit direct de platformă — disponibil și în medii air-gapped.',
    manualLink: 'Manualul de administrare (PDF)',
    apiExplorerTitle: 'Explorator API',
    apiExplorerSubtitle: 'Contractul OpenAPI, navigabil',
    apiExplorerBody: 'Contractul OpenAPI complet al platformei — fiecare rută, schemă și cod de răspuns — explorabil din browser, servit prin acest nod.',
    apiExplorerLink: 'Explorează API',
    kubeTitle: 'Compatibilitate Kubernetes',
    kubeSubtitle: 'kubectl și uneltele sale, în fața API-ului nativ',
    kubeBody: 'TVirt KubeCompat proiectează Pod-uri, Deployment-uri, Service-uri, namespace-uri, noduri și evenimente în dialectul Kubernetes — doar citire, plus ștergerea Deployment-urilor. Fiecare apel trece prin API-ul nativ cu permisiunile tale: în kubeconfig folosește un app token ca bearer.',
    kubeEndpoint: 'Endpoint pentru kubectl',
    kubeStatusActive: 'Activ — Kubernetes {version}',
    kubeStatusMissing: 'Neinstalat pe acest nod (pachetul trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Instalat, dar nu răspunde — verifică unitatea trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Se verifică…'
  },
  licensing: {
    title: 'Licența clusterului',
    subtitle: 'Licență pe bază de abonament — cel mult una per cluster',
    absentTitle: 'Nicio licență înregistrată',
    absentBody:
      'Fără o licență validă, clusterul refuză să pornească mașini virtuale noi (VM-urile pornite rămân pornite). Înregistrează cheia de produs primită cu abonamentul.',
    registerButton: 'Înregistrează licența',
    removeButton: 'Elimină licența',
    state: {
      ok: 'Validă',
      limitExceeded: 'Limită depășită',
      expired: 'Expirată'
    },
    productKeyLabel: 'Cheie de produs',
    basisLabel: 'Baza limitei',
    basis: {
      concurrentVms: 'VM-uri pornite simultan',
      physicalCores: 'Core-uri fizice (total pe cluster)'
    },
    limitLabel: 'Limită',
    usageLabel: 'Utilizare curentă',
    usageOf: '{used} din {limit}',
    usagePartial: 'sumă parțială — noduri fără topologie CPU observată: {n}',
    usageUnknown: 'neobservabilă momentan',
    expiresLabel: 'Expiră',
    neverExpires: 'niciodată',
    registeredLabel: 'Înregistrată',
    gateNote:
      'Cu licența absentă, expirată sau peste limită, clusterul refuză să pornească mașini virtuale NOI. VM-urile pornite rămân pornite, iar repornirile HA nu sunt afectate.',
    devStage:
      'Fază de dezvoltare: cheia de produs este acceptată ca atare, împreună cu limitele declarate aici; validarea cu cheie semnată va sosi într-un release viitor.',
    dialogTitle: 'Înregistrează licența',
    dialogExpiresHelp: 'Gol = licența nu expiră niciodată',
    dialogSubmit: 'Înregistrează',
    dialogError: 'Nu s-a putut înregistra licența.',
    removeTitle: 'Elimină licența',
    removeBody:
      'Clusterul va rămâne FĂRĂ LICENȚĂ: mașinile virtuale noi vor refuza să pornească până când înregistrezi una. VM-urile pornite rămân pornite.',
    removeConfirm: 'Elimină',
    removeError: 'Nu s-a putut elimina licența.'
  },
  rbac: {
    tabRoles: 'Roluri',
    tabGrants: 'Delegări',
    rolesTitle: 'Roluri',
    createRoleTitle: 'Creează rol',
    editRoleTitle: 'Modifică rolul',
    nameHint: 'Litere mici, cifre și cratime; prefixul tvirt- este rezervat',
    systemChip: 'Sistem',
    permissions: 'Permisiuni',
    permissionsPlaceholder: 'Adaugă permisiune…',
    includedRoles: 'Roluri incluse',
    includedRolesPlaceholder: 'Adaugă rol…',
    grantsTitle: 'Delegări',
    createGrantTitle: 'Creează delegare',
    principal: 'Principal',
    principalKind: 'Tip de principal',
    principalUser: 'Utilizator',
    principalGroup: 'Grup',
    role: 'Rol',
    grantRight: 'Delegare',
    grantRightChip: 'Poate delega',
    grantRightLabel: 'Cu drept de delegare (destinatarul poate delega la rândul lui acest rol)',
    effective: 'Efectivă',
    notEffective: 'Nu este efectivă',
    createdAt: 'Creată',
    scopeHint: '/path exact, /path/* recursiv — delegările se ancorează la o rădăcină montată (/* nu este delegabil)'
  },
  groups: {
    title: 'Grupuri',
    createTitle: 'Creează grup',
    nameHint: 'Litere mici, cifre și cratime; unic în scope',
    members: 'Membri',
    membersTitle: 'Membri',
    membersPlaceholder: 'Adaugă utilizator…',
    noMembers: 'Niciun membru',
    realmMappings: 'Mapări de realm',
    realmMappingsTitle: 'Mapări de realm',
    realmMappingsHint:
      'Cu ce corespunde acest grup în fiecare realm extern. Apartenența se citește din director la conectare: un grup din director pe care nu-l mapează nimeni aici este ignorat, iar imbricarea nu se rezolvă — trebuie aplatizată pe partea directorului.',
    realm: 'Realm',
    externalGroup: 'Grup extern',
    addRealmMapping: 'Adaugă mapare',
    removeRealmMapping: 'Elimină maparea',
    noRealmMappings: 'Nicio mapare de realm',
    sectionGeneral: 'General',
    mappingsNoRealms: 'Niciun realm extern configurat — suprafața de mapare se deblochează imediat ce există un realm.',
    mappingsNoRealmsLink: 'Deschide fila Realmuri și SSO',
    mfaRequired: 'Obligație MFA',
    mfaRequiredChip: 'Impune MFA',
    mfaNotRequiredChip: 'Nicio obligație',
    mfaRequiredHint:
      'OR pur: un grup poate ADĂUGA obligația celui de-al doilea factor membrilor săi — inclusiv identităților externe, prin mapările de realm — dar niciodată să o ridice. Se aplică de la următoarea conectare: sesiunile deschise nu sunt închise.'
  },
  users: {
    title: 'Utilizatori',
    createTitle: 'Creează utilizator',
    editTitle: 'Modifică utilizatorul',
    username: 'Nume de utilizator',
    usernameHint: 'Litere mici, cifre, puncte și cratime',
    displayName: 'Nume afișat',
    enabled: 'Activat',
    state: 'Stare',
    enabledChip: 'Activat',
    disabledChip: 'Dezactivat',
    lockedChip: 'Blocat',
    password: 'Parolă',
    passwordSetChip: 'Setată',
    mustChangeChip: 'De schimbat',
    initialPassword: 'Parolă inițială',
    initialPasswordHint: 'Utilizatorul va trebui să o schimbe la prima conectare',
    lastLogin: 'Ultima conectare',
    neverLoggedIn: 'Nu s-a conectat niciodată',
    setPasswordTitle: 'Setează parola',
    setPasswordHint: 'Înlocuire administrativă — necesită parola ta (mod sudo) și obligă utilizatorul să o schimbe la următoarea conectare.',
    operatorPassword: 'Parola ta',
    unlock: 'Deblochează contul',
    revokeTitle: 'Revocă sesiunile',
    revokeBody: 'Toate sesiunile active ale acestui utilizator sunt terminate imediat.',
    revokeIncludeTokens: 'Revocă și tokenurile de aplicație',
    revokeConfirm: 'Revocă',
    tabAccount: 'Cont',
    tabSecurity: 'Securitate',
    usernameImmutableHint: 'Numele de utilizator este identitatea contului — fixat la creare',
    groups: 'Grupuri',
    noGroups: 'Niciun grup',
    mustChangePassword: 'Schimbarea parolei este obligatorie',
    failedAttempts: 'Încercări de conectare eșuate',
    lockedUntil: 'Blocat până la',
    tabUsers: 'Utilizatori',
    tabGroups: 'Grupuri',
    tabRealms: 'Realmuri și SSO',
    tabMfa: 'MFA',
    mfa: {
      title: 'Al doilea factor (MFA)',
      methodsTitle: 'Metode disponibile',
      methodsSubtitle: 'Ceea ce această instalare poate verifica drept al doilea factor',
      methodsError: 'Nu s-a putut încărca registrul metodelor',
      builtinChip: 'Integrat',
      enrollableChip: 'Enrollment în TVirt',
      delegatedChip: 'Gestionat extern',
      state: 'Stare',
      stateActive: 'Activ',
      statePending: 'În așteptarea enrollment-ului',
      stateNone: 'Neînrolat',
      required: 'Obligație MFA',
      requiredChip: 'Obligatoriu',
      notRequiredChip: 'Neobligatoriu',
      enrolledAt: 'Enrollment din',
      enrolledMethods: 'Metode înrolate',
      noMethods: 'Niciun enrollment',
      codesRemaining: 'Coduri de recuperare rămase',
      resetTitle: 'Resetează al doilea factor',
      resetHint:
        'Enrollment-ul și toate codurile de recuperare sunt șterse: la următoarea conectare utilizatorul reface enrollment-ul de la zero. Obligația MFA rămâne așa cum este — un administrator nu setează niciodată un secret, doar îl șterge.',
      resetConfirm: 'Resetează',
      resetError: 'Nu s-a putut reseta al doilea factor',
      empty: 'Încă niciun utilizator gestionat — conturile apar aici imediat ce există, fiecare cu starea celui de-al doilea factor al său.',
      viaSelf: 'Personal',
      viaSelfHint: 'Contribuția personală a contului (flagul său) — singura parte pe care o modifică creionul.',
      viaGroupHint: 'Obligație moștenită de la acest grup: eliminarea flagului personal nu eliberează utilizatorul — se intervine pe grup, în fila Grupuri.',
      subject: 'Identitate',
      lastSeenAt: 'Ultima confirmare',
      enrollmentPending: 'În așteptare',
      orphanChip: 'Orfan',
      orphanDirectoryMiss: 'Identitatea nu mai este în director',
      orphanRealmRemoved: 'Realmul a fost eliminat din TVirt',
      orphanedAt: 'Orfan din',
      directoryUuid: 'UUID în director',
      externalTitle: 'Enrollment-uri externe',
      externalEmpty: 'Încă niciun enrollment extern — se naște la prima conectare a unei identități din director aflate sub obligația MFA.',
      orphanHelp:
        'Un enrollment orfan nu se șterge niciodată de la sine: este material de securitate — rămâne pentru audit și, dacă identitatea reapare în director, își regăsește factorul. Singura ieșire este resetarea administrativă.',
      visibilityHint: 'Enrollment-urile externe locuiesc la rădăcina clusterului: le vede doar cine deține user.read pe întregul arbore.',
      orphanResetHint:
        'Rândul orfan este eliminat definitiv: nu îl mai revendică nimeni. Dacă identitatea va reapărea în director, va reface enrollment-ul de la zero.',
      enforcingTitle: 'Grupuri care impun MFA',
      enforcingSubtitle:
        'Ancora obligației pentru identitățile externe este grupul: mapările sale de realm spun la ce populație din director ajunge. Enrollment-ul extern se naște la prima conectare a utilizatorului obligat.',
      enforcingEmpty: 'Niciun grup nu impune MFA — obligația se activează pe grup, din fila Grupuri.',
      enforcingError: 'Nu s-au putut încărca grupurile care impun MFA'
    }
  },
  realms: {
    title: 'Realmuri de autentificare',
    createTitle: 'Creează realm',
    editTitle: 'Modifică realmul',
    name: 'Realm',
    nameHint: 'Domeniul pe care utilizatorii îl scriu după @ (example.com) — imutabil după creare',
    nameImmutableHint: 'Numele realmului este imprimat în fiecare sesiune și în fiecare linie de audit care l-a numit vreodată — redenumirea ar rescrie istoria',
    kind: 'Tip',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC și SAML sosesc în rundele următoare — astăzi un realm este un director LDAPv3',
    kindCategory: 'Tip de realm',
    kindSelectHint: 'Selectează tipul de director față de care acest realm va autentifica.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Username și parolă verificate printr-un bind pe un director LDAPv3 — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Single sign-on din browser, delegat unui identity provider OpenID Connect — sosește în rundele următoare.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Single sign-on de întreprindere prin aserțiuni SAML 2.0 — sosește în rundele următoare.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Activat',
    urls: 'Serverele directorului',
    urlsHint: 'Un URL ldap:// sau ldaps:// pe linie (1–8), încercate în ordine — failover, niciodată balansare',
    startTls: 'StartTLS',
    verifyCertificate: 'Verifică certificatul',
    cleartextWarning: 'Fără ldaps:// sau StartTLS, parola de bind traversează rețeaua în clar — acceptabil într-un laborator, niciodată în producție.',
    noVerifyWarning: 'O sesiune TLS neverificată nu autentifică pe nimeni: dezactivează verificarea doar față de un director pe care nu-l poți repara.',
    caCertificate: 'Certificat CA (PEM)',
    caCertificateHint: 'Bundle CA opțional, fixat pentru handshake-ul TLS/StartTLS al acestui realm; gol îl elimină',
    caCertificatePinned: 'Fixat',
    connectTimeout: 'Timeout (secunde)',
    connectTimeoutHint: 'Termen per-URL de conectare și cerere (1–60); la expirare se încearcă următorul URL',
    bindDn: 'Bind DN',
    bindDnHint: 'Contul de serviciu care execută căutarea utilizatorului; gol = search bind anonim (refuzat de AD)',
    anonymousBind: 'Search bind anonim',
    bindCredential: 'Parola de bind (keystore)',
    bindCredentialHint: 'O intrare usernamePassword din keystore cu parola de bind — secretul nu trăiește niciodată pe realm',
    bindCredentialNone: 'Niciuna (bind anonim)',
    bindCredentialEmpty: 'Nicio intrare usernamePassword în keystore — creează una în Sistem > Credențiale pentru parola de bind.',
    baseDn: 'Base DN',
    baseDnHint: 'Subarborele din care pornește căutarea utilizatorului (DC=example,DC=com)',
    userFilter: 'Filtru utilizator',
    userFilterHint: '%u este înlocuit cu partea locală a numelui de conectare, cu escape RFC 4515; directoarele non-AD vor de regulă (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'Atributul memberOf',
    memberOfAttributeHint: 'Citit o singură dată, la conectare — grupurile nemapate se ignoră, imbricarea nu se rezolvă',
    uuidAttribute: 'Atributul UUID',
    uuidAttributeHint: 'UUID-ul imutabil în realm (objectGUID pe AD, entryUUID pe OpenLDAP) — imprimat în audit lângă utilizator@realm',
    displayNameAttribute: 'Atributul numelui afișat',
    displayNameAttributeHint: 'Folosit pentru a saluta utilizatorul; în lipsă se folosește numele de conectare',
    sudoHint: 'Scrierile pe realmuri sunt protejate prin sudo: un realm este o poartă de intrare în platformă',
    deleteBody: 'Mapările de grupuri ale realmului pleacă odată cu el; sesiunile pe care le-a autentificat rămân vii până la expirare — un realm șters pur și simplu nu mai primește pe nimeni nou.',
    tabConnection: 'Conexiune',
    tabDirectory: 'Director',
    testTitle: 'Testează conexiunea',
    testHint: 'O sondă de configurare, niciodată o autentificare: se conectează, face bind cu contul de serviciu și — cu un nume de utilizator — execută filtrul de utilizator.',
    testUsername: 'Nume de utilizator (opțional)',
    testUsernameHint: 'O parte locală pe care să se ruleze filtrul de utilizator — 1 potrivire este răspunsul sănătos',
    testRun: 'Rulează testul',
    testError: 'Sonda nu a putut fi rulată',
    testReachable: 'Director accesibil, bind de serviciu acceptat',
    testUnreachable: 'Directorul NU este accesibil',
    matchedOne: 'Filtrul de utilizator a găsit exact 1 intrare — răspunsul sănătos.',
    matchedNone: 'Filtrul de utilizator nu a găsit nicio intrare: filtrul sau Base DN-ul este greșit.',
    matchedMany: 'Intrări găsite de filtrul de utilizator: {count} — filtrul nu este selectiv, iar conectările ar fi ambigue (refuzate).',
    mappingsPointer: 'Cu ce corespunde un grup extern este o proprietate a grupului TVirt (mapările sale de realm): punctul de adevăr trăiește în fila Grupuri.',
    mappingsPointerLink: 'Deschide fila Grupuri',
    rootHomeHint: 'Identitățile unui realm extern trăiesc la rădăcina clusterului, niciodată într-un vDC: permisiunile se atribuie acolo unde este nevoie, prin delegări — pe grup sau direct pe utilizator, exact ca pentru cei nativi.'
  },
  credentials: {
    title: 'Credențiale',
    createTitle: 'Creează credențială',
    editTitle: 'Modifică credențiala',
    kind: 'Tip',
    kindUsernamePassword: 'Username și parolă',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (identitate Ceph)',
    kindHintUsernamePassword: 'Imutabilă. Pentru storage-urile CIFS/SMB — contul de montare al cărui secret workerul îl folosește la montare.',
    kindHintIscsiChap: 'Imutabilă. Pentru autentificarea CHAP iSCSI — username = numele CHAP, secret = secretul CHAP.',
    kindHintNvmeDhchap: 'Imutabilă. Pentru DH-HMAC-CHAP din NVMe over Fabrics — secret = blobul DHHC-1:xx:…; username-ul este doar o etichetă.',
    kindHintCephx: 'Imutabilă. Pentru clienții Ceph — username = numele clientului (client.…), secret = cheia base64.',
    kindImmutableHint: 'Tipul este imutabil după creare — schimbarea lui înseamnă o credențială nouă.',
    username: 'Nume de utilizator',
    usernameChap: 'Nume CHAP',
    usernameNvme: 'Etichetă',
    usernameCephx: 'Nume client',
    usernameHint: 'Contul opțional căruia îi aparține secretul',
    usernameHintChap: 'Numele CHAP cu care se autentifică initiatorul',
    usernameHintNvme: 'Nefolosită de transport — o etichetă liberă pentru evidența ta',
    usernameHintCephx: 'Numele clientului cephx — prefixul client. este tolerat',
    secret: 'Secret',
    secretHint: 'Doar scriere: folosit de consumatori, niciodată afișat din nou.',
    secretHintNvmeDhchap: 'Doar scriere: secretul DH-HMAC-CHAP al hostului în forma canonică DHHC-1:xx:… — folosit de consumatori, niciodată afișat din nou.',
    secretHintCephx: 'Doar scriere: cheia cephx base64 — folosită de consumatori, niciodată afișată din nou.',
    secretEditHint: 'Lasă gol pentru a nu schimba secretul — completarea lui îl rotește.',
    createdAt: 'Creată',
    inUseError: "'{name}' este referențiată de configurația unui storage — detașeaz-o mai întâi acolo.",
    nameHint: 'Litere mici, cifre și cratime (DNS-1123); unică per scope',
    rotateTitle: 'Rotește secretul',
    rotateHint: 'Doar scriere: noul secret îl înlocuiește pe cel memorat — consumatorii îl vor folosi la următoarea montare.',
    tabSecrets: 'Secrete',
    tabCertificates: 'Certificate',
    tabAuthorities: 'Autorități de certificare',
    certificatesTitle: 'Certificate',
    authoritiesTitle: 'Autorități de certificare',
    caCreateTitle: 'CA nouă',
    certCreateTitle: 'Certificat nou',
    caMode: 'Sursă',
    caModeGenerate: 'Generează cu TVirt',
    caModeImport: 'Importă (cheie + certificat)',
    certMode: 'Sursă',
    certModeIssue: 'Emite dintr-o CA din keystore',
    certModeImport: 'Importă (cheie + certificat)',
    issuingCa: 'CA emitentă',
    issuingCaHint: 'Certificatul se naște în scope-ul CA, cu părintele înregistrat',
    noCasHint: 'Nicio CA în keystore — generează sau importă mai întâi una în fila CA',
    commonName: 'Common name (CN)',
    commonNameCaHint: 'Subject-ul CA: litere, cifre, spațiu, punct, underscore, cratimă',
    commonNameCertHint: 'OpenVPN identifică clienții după CN — păstrează-l unic per CA',
    days: 'Valabilitate (zile)',
    daysCaHint: '1–7300 de zile; 3650 (10 ani) este valoarea implicită',
    daysCertHint: '1–3650 de zile; 365 este valoarea implicită',
    keyType: 'Tip de cheie',
    keyTypeHint: 'EC P-256 este valoarea implicită; RSA pentru consumatori legacy',
    usage: 'Utilizare',
    usageClient: 'Client (clientAuth)',
    usageServer: 'Server (serverAuth)',
    usageHint: 'Extended key usage pentru care este emis certificatul',
    san: 'Nume alternative (SAN)',
    sanHint: 'Separate prin virgulă; literalele IP devin intrări IP:, restul DNS:',
    keyPem: 'Cheie privată (PEM)',
    keyPemHint: 'Doar scriere: păstrată în keystore, niciodată afișată din nou',
    certPem: 'Certificat (PEM)',
    certPemHint: 'Certificatul public care se împerechează cu cheia',
    certPemCaHint: 'Certificatul CA care se împerechează cu cheia (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Emitent',
    parentCa: 'CA emitentă',
    parentCaImported: 'Importat — emis în afara TVirt',
    serial: 'Serial',
    fingerprint: 'Fingerprint (SHA-256)',
    validFrom: 'Valid de la',
    validUntil: 'Valid până la',
    expiry: 'Expirare',
    expired: 'Expirat',
    expiresInDays: 'Expiră în {days} z',
    revoked: 'Revocat',
    revokedAtLabel: 'Revocat la',
    revokeTitle: 'Revocă certificatul',
    revokeAction: 'Revocă',
    revokeWarning: 'Revocarea este definitivă: serialul intră în CRL-ul CA emitente, iar orice consumator care refuză certificatele revocate (OpenVPN în primul rând) îl va respinge pe acesta. Nu există un-revoke.',
    exportPem: 'Exportă PEM',
    exportChain: 'Exportă bundle-ul lanțului',
    exportCrl: 'Exportă CRL',
    materialImmutableHint: 'Materialul X.509 este imutabil — emite din nou sau importă din nou',
    caInUseError: "'{name}' încă are certificate emise vii (sau un storage o referențiază) — revocă-le sau șterge-le mai întâi."
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Plasare, disponibilitate și afinitate — unde rulează VM-urile clusterului și dacă trebuie să fie pornite',
    loadError: 'Panoul Proximity are nevoie de store-ul clusterului — starea flotei nu este accesibilă acum',
    config: {
      title: 'Configurare',
      subtitle: 'Politică de plasare la nivel de cluster',
      save: 'Salvează',
      saveError: 'Configurarea a fost refuzată',
      strategy: 'Strategie de selecție',
      strategy_leastUsedResources: 'Cele mai puține resurse folosite',
      strategy_leastVms: 'Cele mai puține VM-uri',
      strategy_random: 'Aleatorie',
      strategyLeastUsedResourcesHint: 'Dintre candidații valizi, nodul cu cea mai multă RAM utilizabilă rămasă (total observat − rezervă host − VM-uri pornite), angajamentul vCPU ca departajare. Deterministă la date egale.',
      strategyLeastVmsHint: 'Dintre candidații valizi, nodul cu cele mai puține VM-uri pornite; egalitățile se rezolvă după numele nodului. Deterministă la date egale.',
      strategyRandomHint: 'Uniform aleatorie între candidații valizi.',
      liveness: 'Prag de vitalitate a nodurilor (secunde)',
      livenessHint: 'Un membru tăcut peste acest prag este inaccesibil: exclus de la plasare și — dacă nu este în mentenanță — considerat mort de deciderul HA, care îl izolează (fencing) și îi repornește VM-urile HA în altă parte.',
      decider: 'Decider HA',
      deciderNone: 'încă neales'
    },
    nodesTitle: 'Noduri',
    nodesSubtitle: 'Vitalitate și capacitate empirică — RAM utilizabilă = total − bază − angajată',
    nodeCol: 'Nod',
    stateCol: 'Stare',
    ramCol: 'RAM (total − bază − angajată)',
    usableCol: 'Utilizabilă',
    vmsCol: 'Încărcare',
    neverSeen: 'nevăzut niciodată',
    freshChip: 'accesibil',
    staleChip: 'inaccesibil',
    attestedChip: 'atestat stins',
    ramFormula: 'total − bază − angajată',
    haTitle: 'Disponibilitate înaltă',
    haSubtitle: 'VM-urile cu flag HA sunt „mereu pornite”: TVirt le repornește după orice oprire necerută — același nod cu backoff, alt nod când al lor moare (doar storage partajat).',
    haNone: 'Nicio VM nu are încă flagul HA — activează-l aici sau în detaliul VM-ului.',
    haVmCol: 'Mașină virtuală',
    haStateCol: 'Stare',
    haRestartsCol: 'Reporniri HA',
    haLastEventCol: 'Ultimul eveniment',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'Modificarea HA a fost refuzată',
    rules: {
      title: 'Reguli de afinitate',
      createTitle: 'Regulă de proximitate nouă',
      editTitle: 'Modifică regula',
      nameHint: 'Litere mici, cifre și cratime (etichetă DNS)',
      vms: 'Mașini virtuale',
      vmsHint: 'Cel puțin două VM-uri — regula leagă unde rulează unele față de altele',
      type: 'Tip',
      affinity: 'Afinitate (împreună)',
      antiAffinity: 'Anti-afinitate (separate)',
      typeAffinityHint: 'VM-urile trebuie să ruleze pe ACELAȘI nod.',
      typeAntiAffinityHint: 'VM-urile trebuie să ruleze pe noduri DIFERITE — clasica pereche HA.',
      mode: 'Mod',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Încălcările refuză operația (pornire, migrare, failover) cu o eroare grăitoare.',
      modeSoftHint: 'Preferință, niciodată blocantă: o plasare în încălcare continuă cu un avertisment vizibil.',
      satisfied: 'Plasare',
      satisfiedYes: 'respectată',
      satisfiedNo: 'încălcată',
      violations: 'Încălcări',
      noViolations: 'Niciuna'
    },
    events: {
      title: 'Evenimente HA',
      subtitle: 'Jurnalul disponibilității — reporniri, fencing, failover-uri și omisiunile oneste',
      none: 'Încă nimic.',
      when: 'Când',
      kind: 'Eveniment',
      target: 'Țintă',
      detail: 'Detaliu',
      kindRestarted: 'repornire HA',
      kindGaveUp: 'renunțare (crash loop)',
      kindNodeAttested: 'nod izolat (fencing)',
      kindFailedOver: 'failover',
      kindNoCandidate: 'niciun candidat',
      kindStorageLocalSkip: 'omisă (storage local)',
      kindZombieFenced: 'zombie terminat'
    }
  }
}
